import { IFieldResetOptions } from '@formily/core'
import { observer } from '@formily/reactive-vue'
import { h, useParentForm } from '@formily/vue'
import { defineComponent } from 'vue-demi'

import type { Button as IElButton } from '@didi-pebble/pebble-design-vue'
import { Button as ElButton } from '@didi-pebble/pebble-design-vue'

export type ResetProps = IFieldResetOptions & IElButton

export const Reset = observer(
  defineComponent<ResetProps>({
    name: 'FReset',
    props: {
      forceClear: {
        type: Boolean,
        default: false,
      },
      validate: {
        type: Boolean,
        default: false,
      },
    },
    setup(props, context) {
      const formRef = useParentForm()
      const { listeners, slots } = context
      return () => {
        const form = formRef?.value
        return h(
          ElButton,
          {
            attrs: context.attrs,
            on: {
              ...listeners,
              click: (e: any) => {
                if (listeners?.click) {
                  if (listeners.click(e) === false) return
                }
                form
                  ?.reset('*', {
                    forceClear: props.forceClear,
                    validate: props.validate,
                  })
                  .then(listeners.resetValidateSuccess as (e: any) => void)
                  .catch(listeners.resetValidateFailed as (e: any) => void)
              },
            },
          },
          slots
        )
      }
    },
  })
)

export default Reset
